import { ReportFileFormat } from './dashboard.interfaces';

export function getFileName(reportName: string, fileFormat?: ReportFileFormat): string {
  return [reportName, fileFormat?.toLowerCase()].filter(Boolean).join('.');
}
